import React from "react";
import { Info } from "lucide-react";

export const LegalNotice = () => (
  <section className="px-4 sm:px-8 lg:px-16 max-w-4xl mx-auto py-12 md:py-16">
    <div
      data-testid="legal-notice"
      className="bg-white border border-[var(--oz-border)] rounded-[1.5rem] p-7 md:p-9 shadow-[0_20px_50px_-35px_rgba(26,23,20,0.4)]"
    >
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded-full bg-[var(--oz-nude)] flex items-center justify-center text-[var(--oz-badge)]">
          <Info className="w-5 h-5" />
        </div>
        <h3 className="font-serif text-xl sm:text-2xl text-[var(--oz-text)]">Information importante</h3>
      </div>
      <div className="space-y-4 text-sm text-[var(--oz-muted)] leading-relaxed">
        <p>
          En tant qu'acheteur particulier, la revente occasionnelle de produits peut être possible.
          Lorsque la revente devient habituelle, régulière et exercée dans un objectif lucratif, elle
          peut constituer une activité commerciale professionnelle.
        </p>
        <p>
          Le revendeur est responsable de vérifier les obligations administratives, fiscales et
          sociales applicables à sa situation et, le cas échéant, de disposer du statut professionnel
          approprié.
        </p>
        <p className="font-semibold text-[var(--oz-text)]">
          Ozentya ne se substitue pas au revendeur dans l'accomplissement de ses obligations légales,
          fiscales, sociales ou administratives.
        </p>
        <p>Le revendeur agit en son nom et sous sa propre responsabilité.</p>
        <p className="text-xs italic text-[var(--oz-muted)]/80">
          Cette information est fournie à titre général et ne constitue pas un avis juridique.
        </p>
      </div>
    </div>
  </section>
);
